
import Vue from "vue";
import { mapGetters } from "vuex";
import { HeadData } from "@/interfaces/recruiter/jobs/job_listing/listing_thead";
import CandidateInterviewListingBody from "@/components/candidate/interviews/CandidateInterviewListingBody.vue";
import CandidateInterviewListingHeader from "@/components/candidate/interviews/CandidateInterviewListingHeader.vue";
import { SITE_DIRECTION } from "@/store/modules/common/constants";

export default Vue.extend({
  name: "CandidateInterviewsListing",
  components: {
    CandidateInterviewListingHeader,
    CandidateInterviewListingBody
  },
  data() {
    return {
      table_headers: [] as HeadData[],
      statusFilter: "all" as string | null
    };
  },
  mounted() {
    this.intializeTableHeaders();
  },
  computed: {
    ...mapGetters("common", {
      get_site_direction: SITE_DIRECTION
    })
  },
  watch: {
    get_site_direction() {
      this.intializeTableHeaders();
    }
  },
  methods: {
    intializeTableHeaders() {
      this.table_headers = [
        {
          title: this.$t("recruiter.interview.listing.date-col")
        },
        {
          title: this.$t("recruiter.interview.listing.job-col")
        },
        {
          title: this.$t("recruiter.interview.listing.status-col")
        },
        {
          title: this.$t("recruiter.interview.listing.actions-col")
        },
        {
          title: this.$t("recruiter.interview.listing.reports-col", "Reports")
        }
      ];
    },
    onStatusFilterChanged(status: string | null) {
      this.statusFilter = status;
    },
    getHeaderColumnWidth(index: number): number {
      // Match the column widths with the data rows: Date(2), Job Title(3), Status(2), Actions(2), Reports(3)
      const columnWidths = [2, 3, 2, 2, 3];
      return columnWidths[index] || 2;
    }
  }
});
